import { HardwareStatusChart, HardwareStatusChartProps, SeriesDetails } from "./HardwareStatusChart";
import { ChartProps } from "react-chartjs-2";
import { TooltipItem } from "chart.js";
import { formatByteSize } from "../../../helpers/generalHelpers";
import { deepMerge } from "../../../helpers/deepMerge";
import { StorageUsageInfo } from "@app/shared";

type StorageUsageChartProps = Omit<HardwareStatusChartProps<StorageUsageInfo>, "series">;

const dataAccessors = (index: keyof StorageUsageInfo) => {
    return {
        date: (data?: StorageUsageInfo) => data?.statusTimestamp,
        xAccessor: (data?: StorageUsageInfo) => data?.statusTimestamp,
        yAccessor: (data?: StorageUsageInfo) => {
            return data?.[index] as number | undefined;
        },
    };
};

const charts: SeriesDetails<StorageUsageInfo>[] = [
    {
        dataKey: "Total",
        accessors: dataAccessors("total"),
    },
    {
        dataKey: "Free",
        accessors: dataAccessors("free"),
    },
    {
        dataKey: "DVR",
        accessors: dataAccessors("dvr"),
    },
    {
        dataKey: "Omnisight",
        accessors: dataAccessors("optOmnisight"),
    },
    {
        dataKey: "Logs",
        accessors: dataAccessors("logs"),
    },
];

export const StorageUsageChart: React.FC<StorageUsageChartProps> = (props) => {
    const mil = 1000000;
    var date2k = new Date(2000, 0, 1); // proper Date constructor for Jan 1, 2000
    var dataMB = props.data
        ?.filter((x) => {
            // handle both Date and string timestamps
            const ts = x?.statusTimestamp;
            const date = ts instanceof Date ? ts : typeof ts === "string" ? new Date(ts) : null;
            return date && !isNaN(date.getTime()) && date > date2k;
        })
        .map((d) => ({ ...d, dvr: d.dvr! / mil, free: d.free! / mil, total: d.total! / mil, optOmnisight: d.optOmnisight! / mil, logs: d.logs! / mil }));
    var chartProps = {
        options: {
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function (tooltipItem: TooltipItem<"line">) {
                            return `${charts[tooltipItem.datasetIndex].dataKey} ${formatByteSize(Math.round(tooltipItem.parsed.y * mil))}`;
                        },
                    },
                },
            },
        },
    } as Partial<ChartProps<"line">>;
    const mergeProps = deepMerge(chartProps, props.chartjsOverrides as any) as any;
    return <HardwareStatusChart {...(props as any)} series={charts} data={dataMB} chartjsOverrides={mergeProps} />;
};
